import { type ReactNode, useEffect, useState } from 'react'
import '@ondit/tokens/loading.css'

/**
 * The seal, spinning, with a sentence under it, for a whole page with nothing
 * drawn yet. A region inside a frame that has already drawn takes a skeleton
 * shaped like its content instead.
 *
 * `slowLabel` is shown after eight seconds — long enough that the first label
 * has stopped being true, short enough that nobody has yet decided the page is
 * broken. Geometry and motion live in `@ondit/tokens/loading.css`; this owns
 * only when the second sentence replaces the first.
 */
export function BrandLoading({
  children,
  label,
  slowLabel,
}: {
  children: ReactNode
  label: string
  slowLabel?: string
}) {
  const [slow, setSlow] = useState(false)
  useEffect(() => {
    if (!slowLabel) return
    const timer = window.setTimeout(() => setSlow(true), 8000)
    return () => window.clearTimeout(timer)
  }, [slowLabel])
  return (
    <div className='brand-loading' role='status' aria-label={label} aria-atomic='true'>
      <span className='brand-loading-mark' aria-hidden='true'>
        {children}
      </span>
      <span className='brand-loading-label'>{slow && slowLabel ? slowLabel : label}</span>
    </div>
  )
}
